import { createFileRoute } from "@tanstack/react-router";
import { EsgPage, esgHead } from "@/pages/EsgPage";

export const Route = createFileRoute("/en/esg")({
  head: () => esgHead("en"),
  component: () => <EsgPage locale="en" />,
});
